// extracted by mini-css-extract-plugin
export default {"privacy-policy":"PrivacyPolicy_privacy-policy__xGbt6"};